@if ($model() != null && $flowDefinitionOrganizationId() != null) {
    <!-- Patriarcas -->
    <div class="form-group ml-3px" featureHint="flowObjectDetails|DocumentClassPatriarch" featureHintHAlign="right">
        <label for="patriarcaId">Selecione um Patriarca para filtrar os Planos abaixo</label>

        <input type="text" class="form-control info-font one-button" id="patriarcaDisplay" name="patriarcaDisplay"
               placeholder="(nenhum selecionado)"
               [ngModel]="$patriarcaDisplay()"
               [matTooltip]="$patriarcaNome()"
               [matAutocomplete]="patriarcaAutocomplete"
               (ngModelChange)="$patriarcaDisplay.set($event)"
               (input)="patriarcaDisplayChange()"
        >

        <mat-autocomplete #patriarcaAutocomplete="matAutocomplete"
                          [displayWith]="displayPatriarcaId"
                          (optionSelected)="patriarcaIdChange($event)"
        >
            @for (option of $selectablePatriarcas(); track option) {
                <mat-option class="uppercase" [value]="option">{{option.sigla}} - {{option.nome}}</mat-option>
            }
        </mat-autocomplete>

        <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearPatriarca()" (keyDown)="clearPatriarca()"></i>
    </div>

    <!-- Planos Ativos -->
    <div class="form-group ml-4" featureHint="flowObjectDetails|DocumentClassActivePlans" featureHintHAlign="right">
        <label for="planoId">Selecione um Plano Ativo para filtrar as Classes abaixo</label>

        <input type="text" class="form-control info-font one-button" id="planoDisplay" name="planoDisplay"
               placeholder="(nenhum selecionado)"
               [ngModel]="$planoDisplay()"
               [matTooltip]="$planoNome()"
               [disabled]="planos.length == 0"
               [matAutocomplete]="planoAutocomplete"
               (ngModelChange)="$planoDisplay.set($event)"
               (input)="planoDisplayChange()"
        >

        <mat-autocomplete #planoAutocomplete="matAutocomplete"
                          [displayWith]="displayPlanoId"
                          (optionSelected)="planoIdChange($event)"
        >
            @for (option of $selectablePlanos(); track option) {
                <mat-option class="uppercase" [value]="option">{{option.codigo}} - {{option.nome}}</mat-option>
            }
        </mat-autocomplete>

        <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearPlano()" (keyDown)="clearPlano()"></i>
    </div>

    <!-- Classes Ativas -->
    <div class="form-group ml-5" featureHint="flowObjectDetails|DocumentClassActiveClasses" featureHintHAlign="right">
        <label for="classeDisplay">Selecione uma das Classes Ativas disponíveis</label>

        <input type="text" class="form-control info-font one-button" id="classeDisplay" name="classeDisplay"
               placeholder="(nenhuma selecionada)"
               [ngModel]="$classeDisplay()"
               [matTooltip]="$model().name"
               [disabled]="classes.length == 0"
               [matAutocomplete]="classeAutocomplete"
               (ngModelChange)="$classeDisplay.set($event)"
               (input)="classeDisplayChange()"
        >

        <mat-autocomplete #classeAutocomplete="matAutocomplete"
                          [displayWith]="displayClasseId"
                          (optionSelected)="classeIdChange($event)"
        >
            @for (option of $selectableClasses(); track option) {
                @if (isActualClasse(option)) {
                    <mat-option class="uppercase" [value]="option">{{option.codigo}} - {{option.nome}}</mat-option>
                } @else {
                    <mat-optgroup class="uppercase">{{option.codigo}} - {{option.nome}}</mat-optgroup>
                }
            }
        </mat-autocomplete>

        <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearClasse()" (keyDown)="clearClasse()"></i>
    </div>

    <!-- Classificação Selecionada -->
    <div class="form-group ml-6" featureHint="flowObjectDetails|DocumentClassSelected" featureHintHAlign="right" featureHintShowOn="top">
        <label for="documentClassName">Classificação Selecionada</label>

        <input type="text" class="form-control info-font one-button" id="documentClassName" name="documentClassName" readonly disabled
               placeholder="(nenhuma)"
               [ngModel]="$model().name"
               [matTooltip]="$model().name"
               (change)="documentClassNameChange($event.target.value)"
        >

        <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearClassificacao()" (keyDown)="clearClassificacao()"></i>
    </div>
}
